/* istanbul ignore file */
export const environment = {
    version: require('../../package.json').version + '-dev',
    production: false,
    api: 'https://smarts-dev.kimley-horn.com/api/',
    url: 'https://smarts-dev.kimley-horn.com/',
    blobStorage: 'https://sasmartsplatformdev.blob.core.windows.net/',
    name: 'SMARTS Platform',
    colors: {
        primaryColor: '#592c82',
        primaryVariantColor: '#835ea0',
        primaryTextColor: '#ffffff',
        primaryBlackColor: "#424553",
        secondaryColor: "#e6e6e6",
        secondaryVariantColor: "#bdbdbd",
        secondaryTextColor: '#353a40',
        backgroundColor: '#ffffff',
        surfaceColor: '#ffffff',
        errorColor: '#a20c33',
    },
    logos: {
        primaryLogo: 'assets/logo-color-primary.svg',
        secondaryLogo: 'assets/logo-color-secondary.png',
    },
    azure: {
        scopes: 'api://d66a8456-6c33-4f3c-90dd-6344b0abcc0d/access_as_user',
        clientId: 'd66a8456-6c33-4f3c-90dd-6344b0abcc0d',
        redirectUri: 'https://smarts-dev.kimley-horn.com/home'
    },
    entraId: {
        tenantId: '7e220d30-0b59-47e5-8a81-a4a9d9afbdc4',
        scopes: 'api://cf8e32d6-f78f-4fdf-898c-2dc1f70c9077/API.Access.User',
        clientId: 'cf8e32d6-f78f-4fdf-898c-2dc1f70c9077',
        redirectUri: 'https://smarts-dev.kimley-horn.com/home',
        authority: 'https://login.microsoftonline.com/7e220d30-0b59-47e5-8a81-a4a9d9afbdc4'
    },
    entraExternalId: {
        tenantId: '8f0e44b3-ca86-4287-b715-d523d0332d9e',
        scopes: 'https://smarts-dev.kimley-horn.com/API.Access.User',
        clientId: '84dc0a48-528e-41e8-8faa-dc46fcd6bfb5',
        redirectUri: 'https://smarts-dev.kimley-horn.com/home',
        authority: 'https://khtsdev.ciamlogin.com/8f0e44b3-ca86-4287-b715-d523d0332d9e'
    },
    internalUserDomains: ['kimley-horn.com', 'kimley-horndc.com'],
    outerHeight: 149,
    developement: false,
    serviceRequestApi: 'https://app-khtscore-servicerequest-dev-southcentralus.azurewebsites.net/ServiceRequest',
    appInsights: {
        instrumentationKey: 'e3ec7b8c-2209-4795-b4d2-91417036b0c2'
    },
    googleMaps: {
        mapIds: {
            streetLabelsNoPOI: '2121d18117d748eae993fcc6',
            noStreetLabelsNoPOI: '2121d18117d748ea8a7bd84b',
            streetLabelsPOI: '2121d18117d748ea1fa97a9b',
            noStreetLabelsPOI: '2121d18117d748eaa609e86e'
        }
    }
};
